import { gql } from '@apollo/client';
import classNames from 'classnames';
import React from 'react';
import Button from '../components/Button';
import SVGIcon from '../components/SVGIcon';
import type { TemplateSidebarItem_PostFragment } from '../graphql/generated/graphqlTypes';
import templateIcon from '../icons/prefilled/template.svg';
import styles from './TemplateSidebarItem.module.scss';

const TEMPLATE_SIDEBAR_ITEM_POST_FRAGMENT = gql`
  fragment TemplateSidebarItem_post on Post {
    id
    title
  }
`;

interface TemplateSidebarItemProps {
  template: TemplateSidebarItem_PostFragment;
  active: boolean;
  onClick: () => void;
}

const TemplateSidebarItem = ({
  template,
  active,
  onClick,
}: TemplateSidebarItemProps) => {
  const content = (
    <>
      <div className={styles.templateIcon}>
        <SVGIcon>{templateIcon}</SVGIcon>
      </div>
      {template.title}
    </>
  );

  return (
    <Button
      onClick={onClick}
      className={classNames(styles.template, { [styles.active]: active })}
    >
      {content}
    </Button>
  );
};

TemplateSidebarItem.fragments = {
  post: TEMPLATE_SIDEBAR_ITEM_POST_FRAGMENT,
};

export default TemplateSidebarItem;
